const ajax = require('@enhancer/fe-util-ajax');
const util = {};

util.getCookie =  function (name) {  
  var i; 
  var cookie;
  var cookieStr;           
  var cookies = document.cookie.split(";");       

  for (i = 0; i < cookies.length; i++) {      
    cookie = cookies[i];            
    cookieStr = cookie.split("=");
    if (cookieStr && cookieStr[0].replace(/^(\s*)|(\s*)$/g, "") == name) {              
        return  decodeURI(cookieStr[1]);        
    }
  }
}


function zero (n) {
  return n > 9 ? n : '0' + n;
}
util.zero = zero;

function format (date, time) {
  date = new Date(date);
  return date.getFullYear() + '-' +  zero(date.getMonth() + 1) + '-' + zero(date.getDate())  
    + (time ? ' ' + zero(date.getHours()) + ':' + zero(date.getMinutes()) : '');
};

util.format = format;

const ajaxObject = {};
function doAjax (data, cb, id, ui) {
  if (ajaxObject[id]) {
    return
  }
  ajaxObject[id] = true;
  ui && ui.addClass('loading');
  ajax(data, function (res) {
    ajaxObject[id] = false;
    if (res.success) {
      cb && cb(res);
    }
    ui && ui.removeClass('loading');
  }, function () {
    ajaxObject[id] = false;
    ui && ui.removeClass('loading');
  });
}
util.ajax = doAjax;


util.getQuery = function  (name) {
  /// escape reg
  const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  const r = window.location.search.substr(1).match(reg);
  if (r != null) return r[2]; return null;
}

module.exports = util;


// WEBPACK FOOTER //
// ./src/app/util.js